import { ExecutionOptions } from "zodiac-roles-deployments";
export const executionFlagsToOptions = (options) => {
    if (options.send && options.delegatecall)
        return ExecutionOptions.Both;
    if (options.delegatecall)
        return ExecutionOptions.DelegateCall;
    if (options.send)
        return ExecutionOptions.Send;
    return ExecutionOptions.None;
};
